import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Switch, Select, Radio, Tooltip, DatePicker} from 'antd'

import './openclass.less'
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TextArea } = Input;
class Openclass extends Component {
	constructor(props) {
		super(props)
		this.state = {
			startTime: "",
			endTime: "",
			corporateName: "",
			createName: "",
			approvalId: '',
			approvalTitle: '',
			approvalReason: '',
			UGCListData: [],
			examineList: [],
			lookContent: {
				images: []
			},
			examineModal: false,
			selectValue: undefined,
			total: 0,
			subjectId: '',
			modelTitle: '新增学科',
			visible: false,
			moreauVisible: false,
			releaseVisible: false,
			postName: '',
			companyName: '',
			url: '',
			qiuniuUrl: '',
			qiuniuUrl2: '',
			subjectName:'',
			jobPositionId: '',
			subjectIcon: null,
			clickUrl: '',
			groupUrl: '',
			zsCourseId: undefined,
			advPic: null,
			changeSwitch: false,
			name: '',
			startCreateTime: '',
			endCreateTime: '',
			time: '',
			publish: '',
			subject: '',
			type: 2,
			jobPositionName: '',
			optionList: [],
			faceListData: [],
			searchData: {
				pageNum: 1,
				pageSize: 10
			},
			vocateSearch: {
				pageNum: 1,
				pageSize: 10,
			},
			imgList: [{
				id: 1,
				url: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
			},{
				id: 2,
				url: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
			}],
			vocatotal: 0,
			ugTotal: 0,
			modelTitel: '',
			userName: '',
			examineColumns: [
				{
					title: '面经标题',
					dataIndex: 'name',
					key: 'name',
					width: '140px',
				},
				{
					title: '审核员',
					dataIndex: 'approvalUserName',
					key: 'approvalUserName',
					width: '140px',
				},
				{
					title: '审核时间',
					dataIndex: 'approvalTime',
					key: 'approvalTime',
					width: '180px',
				},
				{
					title: '审核结果',
					dataIndex: 'approvalStatus',
					key: 'approvalStatus',
					width: '140px',
					render: (record,text)=> {
						return <span>{record === 1? '审核通过' : '审核不通过'}</span>
					}
				},
				{
					title: '不通过原因',
					dataIndex: 'approvalReason',
					key: 'approvalReason',
					render: (record,text)=> {
						return <span>{text.approvalStatus=== 1? '' : record }</span>
					}
				},
			],
			columns: [
				{
					title: '面经标题',
					dataIndex: 'name',
					key: 'name',
					ellipsis : true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '公司',
					dataIndex: 'corporateName',
					key: 'corporateName',
					width: '180px',
				},
				{
					title: '创建人',
					dataIndex: 'createName',
					key: 'createName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '置顶',
					dataIndex: 'top',
					key: 'top',
					align: 'center',
					width: '90px',
					render: (record,text) => {
						return (
							<div>
							{text.publish === 1?<div>
								<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
									 let id = text.id
									 let arr = this.state.faceListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].top = checked===true? 1: 0
											// console.log(text.status)
											this.setState({
												faceListData: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '置顶面经' : '取消置顶'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '确定要置顶吗？' : '确定要取消置顶吗？'}</p>
												</div>
											),
											onOk: () => {
												this.isSureTop(id,checked,'ok')
											},
											onCancel: () => {
												this.isSureTop(id,checked,'cancel')
											}
										})
									)
								}} />

							</div>:''}
							</div>
						)
					}
				},
				{
					title: '发布',
					dataIndex: 'publish',
					key: 'publish',
					align: 'center',
					width: '90px',
					render: (record,text) => {
						return (
							<div>
								<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
									 let id = text.id
									 let arr = this.state.faceListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].publish = checked===true? 1: 0
											this.setState({
												faceListData: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '发布' : '取消发布'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '确定要发布吗？' : '确定要取消发布吗？'}</p>
												</div>
											),
											onOk: () => {
												this.isRelease(id,checked,'ok')
											},
											onCancel: () => {
												this.isRelease(id,checked,'cancel')
											}
										})
									)
								}} />

							</div>
						)
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					width: '166px',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.props.history.push('/newSurface',{courseTitle: '编辑', id: record.id, jobPositionId: this.state.jobPositionId,jobPositionName: this.state.jobPositionName})
						}}>编辑</span>
						{record.publish === 0 ? <span style={{ color: '#f4587e', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除面经',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>面经删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delSurface(record.id)
								},
							});
						}}>删除</span>:''}
					</div>
				},
			],
			vocateColumn: [
				{
					title: '面经标题',
					dataIndex: 'name',
					key: 'name',
					ellipsis: true,
					render: (text, record) => <div className='surText' onClick={() => this.openDetail(record)}><Tooltip placement="topLeft" title={text}><span >{text}</span></Tooltip></div>
				},
				{
					title: '公司',
					dataIndex: 'corporateName',
					key: 'corporateName',
					// width: '180px'
				},
				{
					title: '发布人',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center',
					width: '180px'
				},
				{
					title: '发布时间',
					dataIndex: 'createTime',
					key: 'createTime',
					width: '180px',
					align: 'center'
				},
				{
					title: '面经状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					width: '140px',
					render: (record)=> {
						return <span>{record === 0? '正常' : '用户已删除'}</span>
					}
				},
				{
					title: '审核记录',
					key: 'detail',
					align: 'center',
					width: '140px',
					render: (record,text)=> {
						return <Button type="link" onClick={() => {this.showDetail(record)}}>详情</Button>
					}
				},
				{
					title: '审核状态',
					dataIndex: 'approvalStatus',
					key: 'approvalStatus',
					align: 'center',
					width: '160px',
					render: (record,text)=> {
						return <span style={{ color:(record === 1 ? "green":(record === 0 ? '#666': 'red')) , cursor: 'pointer' }}>{record === 1? '审核通过' : (record === 0? '待审核': '不通过')}</span>
					}
				},
				{
					title: '操作',
					key: 'operate',
					align: 'center',
					width: '200px',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '提示',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>面经审核通过后将在用户端展示，你确定要通过吗？</p>
									</div>
								),
								onOk: () => {
									// this.(record.id)
									this.agreeMoreau(record, 1)
								},
							});
						}}>通过</span>
						{<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={()=> this.disagreeMoreau(record, 0)}>不通过</span>}
					</div>
				}
				// }
			],
			notChanged: []
		}
	}
	// 就业课状态
	// vocatChange = async(checked, obj) => {
	// 	Modal.confirm({
	// 		title: `${checked ? '发布' : '取消发布'}`,
	// 		content: `${checked ? '确定要发布么？' : '确定要取消发布么？'}`,
	// 		okText: '确定',
	// 		cancelText: '取消',
	// 		onOk: () => {
	// 			let url = checked?'employmentcourse/publish':'employmentcourse/cancelPublish'
				
	// 			axios.get(url+'/'+obj.id).then(res => {
	// 				console.log(res)
	// 				if(res.data.code === '200') {
	// 					message.success(`${checked === true ? '发布成功' : `取消成功`}`)
	// 					this.vocatonList()
	// 					Modal.destroyAll();
	// 				}else{
	// 					this.vocatonList()
	// 				}
	// 			})
	// 		},
	// 		onCancel: () => {
	// 			this.vocatonList()
	// 		}
	// 	})
	// }
	tabClick(e) {
		this.setState({
			type: e,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			vocateSearch: {
				pageNum: 1,
				pageSize: 10
			}
		},() => {
			console.log(this.state.type, '选项');
			if(this.state.type === 2){
				this.interList()
			}else{
				this.getUgcList()
			}
		})
	}
	isSureTop(id,checked,type) {
		if(type === 'cancel'){
			this.interList()
		}else{
			let url = checked?`interviewexperience/top/${id}`:`interviewexperience/cancelTop/${id}`
			axios.get(url).then(res => {
				if(res.data.code === '200') {
					message.success(`${checked === true ? '置顶成功' : `取消置顶成功`}`)
					this.interList()
					Modal.destroyAll();
				}else {
					message.error(res.data.msg)
				}
			})
		}
	}
	// 查看审核记录
	showDetail(item) {
		axios.get(`ugc/interviewexperience/approvalRecords/${item.id}`).then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					examineList: arr,
					examineModal: true
				})
			}
		})
	}
	checkedOk(checked, id, type) {
		axios.post('/subjectController/sync',{id: id,syncStatus: checked?1:0,syncType: type}).then(res => {
			// console.log(res)
			if(res.data.code === '200') {
				message.success(`${checked === true ? '同步成功' : `取消${type===1?'题库':type === 2?'资料包':type === 4?'资料广场':type === 5?'课程管理':'资源管理'}同步成功`}`)
				this.getUgcList()
				Modal.destroyAll();
			}else {
				message.error(res.data.msg)
			}
		})
	}
	isRelease = (id,checked,type) => {
		if(type === 'cancel'){
			this.interList()
		}else {
			let url = checked?`interviewexperience/publish/${id}`:`interviewexperience/cancelPublish/${id}`
			axios.get(url).then(res => {
				if(res.data.code === '200') {
					message.success(`${checked === true ? '发布成功' : '取消发布成功'}`)
					this.interList()
					Modal.destroyAll();
				}else {
					// message.error(res.data.msg)
					this.interList()
				}
			})
		}
		
	}
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values)
		});
	}
	async interList() {
		axios.post('interviewexperience/list', {
			...this.state.searchData,
			type: this.state.type,
			name: this.state.name,
			jobPositionId: this.state.jobPositionId,
			createName: this.state.createName,
			corporateName: this.state.corporateName,
			startCreateTime: this.state.startCreateTime,
			endCreateTime: this.state.endCreateTime,
			publish: this.state.publish,
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					total: res.data.data.total,
					faceListData: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
					}
				})
			}
		})
	}
	async getUgcList() { //获取UGC面经
		axios.post('ugc/interviewexperience/list', {
			...this.state.vocateSearch,
			type: this.state.type,
			userName: this.state.userName,
			name: this.state.name,
			jobPositionId: this.state.jobPositionId,
			corporateName: this.state.corporateName,
			endCreateTime: this.state.startCreateTime,
			startCreateTime: this.state.endCreateTime,
			approvalStatus:this.state.approvalStatus
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					ugTotal: res.data.data.total,
					UGCListData: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
					}
				})
				console.log(res.data.data.list, '')
			}
		})
	}
	// 不通过
	disagreeMoreau(item,type) {
		console.log(item)
		this.setState({
			visible: true,
			approvalTitle: item.name,
			approvalId: item.id,
			approvalReason: ''
		})
	}
	// 通过
	agreeMoreau(item,type) {
		let url = `ugc/interviewexperience/pass`
		let params = {
			id: item.id
		}
		if(type !== 1) {
			params.approvalReason = this.state.approvalReason
		}
		axios.post(url,params).then(res => {
			if(res.data.code === '200') {
				message.success('审核成功')
				// this.getUgcList()
				this.tabClick(this.state.type)
			}else {
				message.error(res.data.msg)
			}
		})
	}
	delSurface(id) {
		axios.get(`interviewexperience/delete/${id}`).then(res => {
			if(res.data.code !== '200'){
				message.success('删除成功')
				this.interList()
			}else{
				message.error(res.data.msg)
			}
		})
	}
	// 就业课列表
	// vocatonList() {
	// 	axios.post('employmentcourse/list', {
	// 		...this.state.vocateSearch,
	// 		name: this.state.name,
	// 		// subjectId: this.state.subject,
	// 		publish: this.state.selectValue
	// 	}).then(res => {
	// 		console.log(res)
	// 		if(res.data.code !== '200') return message.error(res.data.msg)
	// 		this.setState({vocateData: res.data.data.list, vocatotal: res.data.data.total, vocateSearch: {pageNum: res.data.data.pageNum, pageSize: res.data.data.pageSize}})
	// 	})
	// }
	handleReason = (e) => {

		this.props.form.validateFields((err, values) => {
			if(!err) {
					axios.post('ugc/interviewexperience/noPass', {
						id:this.state.approvalId,
						approvalReason: values.approvalReason
					}).then(res => {
						if (res.data.code === '200') {
							message.success('提交成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.getUgcList()
						} else {
							message.error(res.data.msg)
						}
					})
				
			}
			
		});
	}
	openDetail  (row) {
		console.log(row)
		this.setState({moreauVisible: true, lookContent:row })
	}
	// handleOk = (e) => {
	// 	let _this = this
	// 	this.props.form.validateFields((err, values) => {
	// 		// console.log(values)
	// 		if(!err) {
	// 			if(this.state.modelTitle === '新增学科'){
	// 				axios.post('subjectController/addSubject', {
	// 					pic: this.state.qiuniuUrl+'/'+values.uploadUrl.response.key,
	// 					name: values.name,
	// 					uploadType: values.uploadUrl.type,
	// 					uploadUid: values.uploadUrl.uid,
	// 					advPic: this.state.qiuniuUrl+'/'+values.advPic.response.key,
	// 					clickUrl: values.clickUrl,
	// 					groupUrl: values.groupUrl,
	// 					zsCourseId: values.zsCourseId
	// 				}).then(res => {
	// 					if (res.data.code === '200') {
	// 						message.success('添加成功')
	// 						this.props.form.resetFields();
	// 						this.setState({ visible: false })
	// 						this.getUgcList()
	// 					} else {
	// 						message.error(res.data.msg)
	// 					}
	// 				})
	// 			}else {
	// 				let pic = values.uploadUrl.url&&values.uploadUrl.url ? values.uploadUrl.url :this.state.qiuniuUrl +'/'+ values.uploadUrl.response.key
	// 				let advPic = values.advPic.url&&values.advPic.url ? values.advPic.url :this.state.qiuniuUrl +'/'+ values.advPic.response.key
	// 				axios.post('subjectController/updateSubject', {
	// 					id: _this.state.subjectId,
	// 					pic: pic,
	// 					name: values.name,
	// 					uploadType: values.uploadUrl.type,
	// 					uploadUid: values.uploadUrl.uid,
	// 					advPic: advPic,
	// 					clickUrl: values.clickUrl,
	// 					groupUrl: values.groupUrl,
	// 					zsCourseId: values.zsCourseId
	// 				}).then(res => {
	// 					if (res.data.code === '200') {
	// 						message.success('编辑成功')
	// 						_this.props.form.resetFields();
	// 						_this.setState({ visible: false })
	// 						_this.getUgcList()
	// 					} else {
	// 						message.error(res.data.msg)
	// 					}
	// 				})
	// 			}
	// 		}
	// 	});
	// }
	backPage() {
		localStorage.setItem('type', 'face')
		this.props.history.push('/QuestionBank')
	}
	componentDidMount() {
		if(this.props.location.state?.id){
			this.setState({
				jobPositionId: this.props.location.state.id,
				jobPositionName: this.props.location.state.name
			},() => {
				if(localStorage.getItem('type')) {
					this.setState({type: localStorage.getItem('type') === 'ugc'?1:2},() => {
						this.getUgcList()
						localStorage.removeItem('type')
					})
				}else{
					this.interList()
				}
			})
		}
		
	}
	onCreateTime = (date, dateString) => {
		this.setState({
			startCreateTime: dateString[0],
			endCreateTime: dateString[1]
		})
	}
	onChangeTime(date, dateString) {
		this.setState({
			startCreateTime: dateString[0],
			endCreateTime: dateString[1]
		})
	}
	componentWillUnmount() {
		this.setState = ()=>false;
	}
	// showModal() {
	// 	this.setState({ visible: true, modelTitle: '新增学科', subjectIcon: '', advPic: '' })
	// 	this.props.history.push('/createSubject',{courseTitle: '新建'})
	// }
	getQiniuUrl  = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	getQiniuUrl2  = v => {
		this.setState({
			qiuniuUrl2: v
		})
	}
 
	render() {
		const { columns, UGCListData,  total, type, ugTotal, faceListData, vocateColumn, jobPositionId, lookContent,visible,jobPositionName,moreauVisible, examineModal,examineList,examineColumns,approvalReason, approvalTitle} = this.state;
		const { getFieldDecorator } = this.props.form;
		const pagination ={
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				// this.getUgcList(searchData)
				this.interList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				// this.getUgcList(searchData)
				this.interList(searchData)
			},
		}
		const usePage ={
			showSizeChanger: true,
			total: ugTotal,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${ugTotal} 条`,
			onShowSizeChange: (current,pageSize) => {

				let vocateSearch = this.state.vocateSearch
				vocateSearch.pageNum = current
				vocateSearch.pageSize = pageSize
				this.getUgcList(vocateSearch)
			},
			onChange: (current) => {
				let vocateSearch = this.state.vocateSearch
				vocateSearch.pageNum = current
				this.getUgcList(vocateSearch)
			},
		}
		const dateFormat = "YYYY-MM-DD"
		
		return (
			<div className="openclass">
				<div className="header-between">
					<span style={{ fontSize: '18px', fontWeight: '600' }}>面经管理</span>
					<span className="my-button-txt" onClick={() => {this.backPage()}}>返回上一级</span>
				</div>
				<Divider />
				<div className='tab-button'>
					<Radio.Group onChange={(e) => {this.tabClick(e.target.value)}} value={type} buttonStyle="solid">
						<Radio.Button value={2}>芯源面经</Radio.Button>
						<Radio.Button value={1}>UGC面经</Radio.Button>
					</Radio.Group>
				</div>
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div style={{ display: 'flex',alignItems: 'center', flexWrap: 'wrap', lineHeight: '52px'}}>
						<span>面经标题：</span><Input allowClear value={this.state.name} style={{ width: '200px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入面经标题"
						onChange={(e)=>{
							this.setState({
									name: e.target.value
							})
						}}
						></Input>
						{type === 1?<div>
							<span>发布人：</span><Input allowClear value={this.state.userName} style={{ width: '200px', height: '40px', marginRight: '20px' }} 
							placeholder="请输入发布人"
							onChange={(e)=>{
								this.setState({
									userName: e.target.value
								})
							}}
							></Input>
						</div>:''}
						<span>公司：</span><Input allowClear value={this.state.corporateName} style={{ width: '200px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入公司"
						onChange={(e)=>{
							this.setState({
								corporateName: e.target.value
							})
						}}
						></Input>
						{type === 2?<div>
							<span>创建人：</span><Input allowClear value={this.state.createName} style={{ width: '180px', height: '40px', marginRight: '20px' }} 
							placeholder="请输入创建人"
							onChange={(e)=>{
								this.setState({
									createName: e.target.value
								})
							}}
							></Input>
						</div>:''}

						{/* {type === 2? */}
						<div><span>{type === 2?'创建':'发布'}时间：</span>
								<RangePicker showTime format={dateFormat} key={this.state.time} onChange={this.onCreateTime} style={{width: '300px', height: '40px',marginRight: '20px'}} />
								</div>
								{/* // :<div><span>发布时间：</span>
								// <RangePicker showTime format={"YYYY-MM-DD"} onChange={this.onChangeTime} style={{marginRight: '20px'}} /> */}
						{/* </div> */}
					{/* } */}

						{type === 2?<div><span>发布状态：</span><Select  placeholder="发布状态" value={this.state.publish} allowClear style={{ width: 110, height: '40px', marginRight: '20px' }} onChange={(value)=>{
						
								this.setState({
									publish: value
									})
								}}>
									<Option value="0">未发布</Option>
									<Option value="1">已发布</Option>
								</Select>
						</div> :''}
						{type === 1?<div><span>审核状态：</span><Select  placeholder="发布状态" value={this.state.approvalStatus} allowClear style={{ width: 140, height: '40px', marginRight: '20px' }} onChange={(value)=>{
								this.setState({
									approvalStatus: value
									})
								}}>
									<Option value="0">待通过</Option>
									<Option value="2">不通过</Option>
									<Option value="1">通过</Option>
								</Select>
						</div> :''}
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.tabClick(type)
						}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={() => {
							this.setState({
								userName: '',
								name: '',
								corporateName: '',
								startCreateTime: '',
								time: new Date(),
								endCreateTime: '',
								ugTotal: 0,
								vocateSearch: {
									pageNum: 1,
								  pageSize: 10,
								},
								searchData: {
									pageNum: 1,
									pageSize: 10
								},
								total: 0,
								publish: undefined,
								approvalStatus: undefined
							},()=>{
								this.tabClick(type)
							})
						}}>重置</span>
					</div>
					{type === 2?
					<Button className='my-button-primary' type='primary' onClick={() => { this.props.history.push('/newSurface', {id: '', jobPositionId, jobPositionName}) }}>新建面经</Button>
					:''
					// this.showModal() <Button className='my-button-primary' type='primary' onClick={(() => {this.props.history.push('/createVocation')})}>新建课程</Button>
					}
				</div>

			{type === 1?
					<Table
						dataSource={UGCListData}
						columns={vocateColumn}
						components={this.components}
						rowKey={record => record.id}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						pagination={usePage}
					/>
				:
					<Table
						dataSource={faceListData}
						columns={columns}
						components={this.components}
						rowKey={record => record.id}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						pagination={pagination}
					/>				
				}
				{/* 面经审核不通过原因 */}
				<Modal
					width={800}
					getContainer={false}
					title={`面经审核不通过原因`}
					okText="确认"
					cancelText="取消"
					visible={visible}
					maskClosable={false}
					destroyOnClose
					onOk={() => { this.handleReason() }}
					onCancel={() => { this.setState({ visible: false }) }}
				>
					<Form labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} onSubmit={this.handleReason}>
						<Form.Item label={"面经标题"}>
						{getFieldDecorator('approvalTitle', {
								initialValue: approvalTitle,
								
							})(
								<TextArea disabled rows={4} placeholder="请输入面经标题"/>
							)}
							
						</Form.Item>
						<Form.Item label={"原因"}>
							{getFieldDecorator('approvalReason', {
								initialValue: approvalReason,
								rules: [{ required: true, message: '请输入原因!' }, { max: 10, message: '最多输入10个字符' }],
							})(
								<TextArea rows={4} placeholder="请输入原因"/>

							)}
						</Form.Item>
						
					</Form>
				</Modal>
				{/* 查看面经 */}
				<Modal
					width={800}
					getContainer={false}
					title={`查看面经`}
					okText="确认"
					cancelText="取消"
					visible={moreauVisible}
					maskClosable={false}
					destroyOnClose
					footer={null}
					onCancel={() => { this.setState({ moreauVisible: false, lookContent: {images: []} }) }}
				>
					<div className='look-model'>
						<div className='look-flex'>
							<span>面经标题：</span>
							<div className='look-text'>{lookContent.name}</div>
						</div>
						<div className='look-flex'>
							<span>面经正文：</span>
							<div className='look-text' dangerouslySetInnerHTML={{__html: lookContent.content}}></div>
						</div>
						<div className='look-flex'>
							<span>岗位名称：</span>
							<div className='look-text'>{jobPositionName}</div>
						</div>
						<div className='look-flex'>
							<span>公司名称：</span>
							<div className='look-text'>{lookContent.corporateName}</div>
						</div>
						<div className='look-flex'>
							<span>面经配图：</span>
							{lookContent.images?<div className='look-text figure-imgs'>
								{lookContent.images.map((item, i) => {
										return (
												<img src={item.url} key={i} alt="" />
										)
								})}
							</div>:''}
						</div>
					</div>
				</Modal>
				{/* 审核记录 */}
				<Modal
					width={800}
					getContainer={false}
					title={`审核记录`}
					visible={examineModal}
					maskClosable={false}
					destroyOnClose
					footer=""
					onCancel={() => { this.setState({ examineModal: false }) }}
				>
              <Table
                dataSource={examineList}
                columns={examineColumns}
                pagination={false}
                components={this.components}
                rowKey={record => record.id + ''} croll={{ y: 500 }}
                rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
              />
				</Modal>
			</div>
		)
	}
}
export default Form.create()(Openclass)
